<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Actualizar Dados</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Inicio</a></li>
          <li class="breadcrumb-item">Professor</li>
          <li class="breadcrumb-item active">Actualizar Professor</li>
        </ol>
      </div>
    </div>
    <!-- end row -->
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title">Actualizar os dados do Professor</div>
        </div>
        <div class="card-body">
          <form action="#" method="post">
            <!-- personal User data -->
            <div v-show="firstInfoShow">
              <h1 class="text-center mb-5">Dados Pessoas</h1>
            </div>
            <div class="row" v-show="firstInfoShow">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Nome Completo*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.fullName"
                  />
                </div>
                     <p v-if="fullname_message_error" style="color: red">
                  {{ fullname_message_error }}
                </p>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Ano de Nascimento*</label>
                  <input
                    type="date"
                    name="datepicker"
                    class="datepicker-default form-control"
                    id="datepicker1"
                    v-model="userData.birthDate"
                  />
                </div>
                   <p v-if="birthDate_message_error" style="color: red">
                  {{ birthDate_message_error }}
                </p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Genero*</label>
                  <select class="form-control" v-model="userData.gender">
                    <option value="Gender">Genero</option>
                    <option value="Male">Masculino</option>
                    <option value="Female">Feminino</option>
                  </select>
                </div>
                 <p v-if="gender_message_error" style="color: red">
                  {{ gender_message_error }}
                </p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Email*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.email"
                    @input="validateEmail"

                  />
                </div>
                <p v-if="emailError" style="color: red">{{ emailError }}</p>

              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Contacto*</label>
                  <input
                    type="text"
                    class="form-control"
                    @keypress="numberOnly"
                    pattern="/^[0-9]+$/"
                    maxlength="9"
                    v-model="userData.contact"
                    @input="validatePhoneNumber"

                  />
                </div>
                <p v-if="phoneNumberError" style="color: red">
                  {{ phoneNumberError }}
                </p>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Contacto Alternativo</label>
                  <input
                    type="text"
                    class="form-control"
                    @keypress="numberOnly"
                    pattern="/^[0-9]+$/"
                    maxlength="9"
                    v-model="userData.alternative_contact"
                    @input="validatePhoneNumberAlternative"
                
                  />
                </div>
                 <p v-if="phoneNumberErrorAlternative" style="color: red">
                  {{ phoneNumberErrorAlternative }}
                </p>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Tem alugma deficiencia?*</label>
                  <select
                    @change="is_deficientChange($event)"
                    class="form-control"
                    v-model="userData.is_deficient"
                  >
                    <option value="">Selecione</option>
                    <option value="0">Nao</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
                  <p v-if="isDeficient_message_error" style="color: red">
                  {{ isDeficient_message_error }}
                </p>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label"
                    >Selecione o tipo de deficiencia</label
                  >
                  <select
                    class="form-control"
                    :disabled="deficientTypeDisabled"
                    v-model="userData.deficient_type"
                  >
                   <option value="Class">Selecione o tipo</option>
                    <option value="Paraplegia">Paraplegia</option>
                    <option value="Paraparesia">Paraparesia</option>
                    <option value="Monoplegia">Monoplegia</option>
                    <option value="Monoparesia">Monoparesia</option>
                    <option value="Tetraplegia">Tetraplegia</option>
                    <option value="Triplegia">Triplegia</option>
                    <option value="Triparesia">Triparesia</option>
                    <option value="Hemiplegia">Hemiplegia</option>
                    <option value="Hemiparesia">Hemiparesia</option>
                    <option value="Amputação">Amputação</option>
                    <option value="Paralisia Cerebral">Paralisia Cerebral</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Nome do Pai*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.fathers_filliation"
                  />
                </div>
                 <p v-if="father_name_message_error" style="color: red">
                  {{ father_name_message_error }}
                </p>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Nome da Mãe*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.mothers_filliation"
                  />
                </div>
                 <p v-if="mother_name_message_error" style="color: red">
                  {{ mother_name_message_error }}
                </p>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <button
                  type="button"
                  class="btn btn-primary float-right"
                  v-on:click="handleNextInfo"
                >
                  Proximo
                </button>
              </div>
            </div>

            <!-- End -->

            <div v-show="secondInfoShow">
              <h1 class="text-center mb-5">Documentaçao</h1>
            </div>
            <div class="row" v-show="secondInfoShow">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecione o tipo documento*</label>
                  <select class="form-control" v-model="userData.doc_type">
                    <option value="">Selecione o tipo documento</option>
                    <option value="Bilhete de Identidade">
                      Bilhete de Identidade
                    </option>
                   </select>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Numero do doc*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.doc_number"
                  />
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Nacionalidade*</label>
                       <select v-model="userData.nactionality" class="form-control">
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Åland Islands">Åland Islands</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antarctica">Antarctica</option>
                    <option value="Antigua and Barbuda">
                      Antigua and Barbuda
                    </option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina">
                      Bosnia and Herzegovina
                    </option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory">
                      British Indian Ocean Territory
                    </option>
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">
                      Central African Republic
                    </option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos (Keeling) Islands">
                      Cocos (Keeling) Islands
                    </option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo, The Democratic Republic of The">
                      Congo, The Democratic Republic of The
                    </option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cote D'ivoire">Cote D'ivoire</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">
                      Dominican Republic
                    </option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands (Malvinas)">
                      Falkland Islands (Malvinas)
                    </option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories">
                      French Southern Territories
                    </option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guernsey">Guernsey</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-bissau">Guinea-bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard Island and Mcdonald Islands">
                      Heard Island and Mcdonald Islands
                    </option>
                    <option value="Holy See (Vatican City State)">
                      Holy See (Vatican City State)
                    </option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran, Islamic Republic of">
                      Iran, Islamic Republic of
                    </option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Isle of Man">Isle of Man</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jersey">Jersey</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Korea, Democratic People's Republic of">
                      Korea, Democratic People's Republic of
                    </option>
                    <option value="Korea, Republic of">
                      Korea, Republic of
                    </option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao People's Democratic Republic">
                      Lao People's Democratic Republic
                    </option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya">
                      Libyan Arab Jamahiriya
                    </option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macao">Macao</option>
                    <option value="Macedonia, The Former Yugoslav Republic of">
                      Macedonia, The Former Yugoslav Republic of
                    </option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia, Federated States of">
                      Micronesia, Federated States of
                    </option>
                    <option value="Moldova, Republic of">
                      Moldova, Republic of
                    </option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambican" selected>
                      Mo&ccedil;ambicana
                    </option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles">
                      Netherlands Antilles
                    </option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands">
                      Northern Mariana Islands
                    </option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Palestinian Territory, Occupied">
                      Palestinian Territory, Occupied
                    </option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russian Federation">
                      Russian Federation
                    </option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Helena">Saint Helena</option>
                    <option value="Saint Kitts and Nevis">
                      Saint Kitts and Nevis
                    </option>
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="Saint Pierre and Miquelon">
                      Saint Pierre and Miquelon
                    </option>
                    <option value="Saint Vincent and The Grenadines">
                      Saint Vincent and The Grenadines
                    </option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">
                      Sao Tome and Principe
                    </option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option
                      value="South Georgia and The South Sandwich Islands"
                    >
                      South Georgia and The South Sandwich Islands
                    </option>
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard and Jan Mayen">
                      Svalbard and Jan Mayen
                    </option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syrian Arab Republic">
                      Syrian Arab Republic
                    </option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania, United Republic of">
                      Tanzania, United Republic of
                    </option>
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-leste">Timor-leste</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">
                      Trinidad and Tobago
                    </option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos Islands">
                      Turks and Caicos Islands
                    </option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">
                      United Arab Emirates
                    </option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands">
                      United States Minor Outlying Islands
                    </option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Viet Nam">Viet Nam</option>
                    <option value="Virgin Islands, British">
                      Virgin Islands, British
                    </option>
                    <option value="Virgin Islands, U.S.">
                      Virgin Islands, U.S.
                    </option>
                    <option value="Wallis and Futuna">Wallis and Futuna</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecione o Provincia*</label>
                  <select
                    class="form-control"
                    v-model="userData.province_id"
                    @change="ChangeProvince($event)"
                  >
                    <option value="0">Selecione o Provincia</option>
                    <option
                      :value="provinces.id"
                      v-for="provinces in provincesData"
                      :key="provinces.id"
                    >
                      {{ provinces.province_name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecione o Distrito*</label>
                  <select
                    :disabled="loadDistricts"
                    class="form-control"
                    v-model="userData.district_id"
                  >
                    <option value="0">Selecione o Distrito</option>
                    <option
                      :value="district.id"
                      v-for="district in districtData"
                      :key="district.id"
                    >
                      {{ district.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Endereco*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.address_location"
                  />
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <button
                  type="button"
                  v-on:click="handleStepTwo"
                  class="btn btn-primary float-right"
                >
                  Proximo
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  v-on:click="handleBackInfo"
                >
                  Voltar
                </button>
              </div>
            </div>

            <div v-show="stepThreeInfo">
              <h1 class="text-center mb-5">Nivel Academico</h1>
            </div>
            <div class="row" v-show="stepThreeInfo">
              <div class="col-lg-6 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label"
                    >Ultima escola que frequentou*</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="userData.last_school_frequency"
                  />
                </div>
              </div>

              <!-- <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Regime*</label>
                  <select class="form-control" v-model="userData.regime">
                    <option value="Gender">Regime</option>
                    <option value="Geral">Geral</option>
                    <option value="Tecnico">Tecnico</option>
                  </select>
                </div>
              </div> -->

              <div class="col-lg-6 col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Ano de Conclusao*</label>
                  <select
                    class="form-control"
                    v-model="userData.last_school_frequency_year"
                  >
                    <option value="Gender">Ano de Frequencia*</option>
                    <option value="Gender">Ano de Frequencia*</option>
                    <option :value="y" v-for="y in years" :key="y">
                      {{ y }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="form-group">
                      <label class="form-label"
                        >Nivel Academico*</label
                      >
                      <select
                      class="form-control"
                      v-model="userData.level_type"
                    >
                      <option value="Gender">Nivel Academico*</option>
                      <option value="Licenciado">Licenciado</option>
                      <option value="Mestrado">Mestrado</option>
                    </select>
                    </div>
                  </div> -->

              <div class="col-lg-12 col-md-12 col-sm-12">
                <button
                  type="button"
                  v-on:click="handleSubmitButton"
                  class="btn btn-primary float-right"
                >
                  {{ loading == false ? "Actualizar" : "Actualizando..." }}
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  v-on:click="handleBackDocument"
                >
                  Voltar
                </button>
              </div>
            </div>

            <!-- <div v-show="stepFourInfo">
                <h1 class="text-center mb-5">Departamento</h1>
              </div>
              <div class="row" v-show="stepFourInfo">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label class="form-label">Selecione o departamento*</label>
                    <Select class="text-white" v-model="userData.department_id" placeholder="Selecione o Departmanto">
                       <Option
                        :value="dep.id"
                        v-for="dep in department"
                        :key="dep.id"
                      >
                        {{ dep.dep_name }}
                      </Option>
                    </Select>
                  </div>
                </div>
  
   
                 <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label class="form-label">Selecione a Turma*</label>
                    <Select   v-model="userData.classmates" multiple placeholder="Selecione a Turma">
                       <Option
                        :value="cl.id"
                        v-for="cl in classmates"
                        :key="cl.id"
                      >
                        {{ cl.name }}
                      </Option>
                    </Select>
                  </div>
                </div>
  
              </div>
              <div class="row" v-show="stepFourInfo">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label class="form-label">Selecione a Disciplina*</label>
                    <Select  multiple  v-model="userData.subjects" placeholder="Selecione a Disciplina">
                       <Option
                        :value="sub.id"
                        v-for="sub in subjects"
                        :key="sub.id"
                      >
                        {{ sub.name }}
                      </Option>
                    </Select>
                  </div>
                </div>
  
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <button
                    type="button"
                    v-on:click="handleStepFive"
                    class="btn btn-primary float-right"
                  >
                    Proximo
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    v-on:click="handleBackNivel"
                  >
                    Voltar
                  </button>
                </div>
  
              </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, onUnmounted, onMounted } from "vue";
import { mapGetters } from "vuex";
import TeacherStoreModule from "./TeacherStoreModule";
import store from "@/store";
import toastr from "toastr";
import DepartmentStoreModule from "../department/DepartmentStoreModule";
import ClassMateStoreModule from "../Classmates/ClassMateStoreModule";
import SubjectStoreModule from "../subject/SubjectStoreModule";
import permissionStoreModule from "../permissions/permissionStoreModule";
import axios from "axios";
import { useRoute } from "vue-router";
import { UserName } from "view-ui-plus";

const firstInfoShow = ref(true);
const secondInfoShow = ref(false);
const stepThreeInfo = ref(false);
const stepFourInfo = ref(false);
const stepFiveInfo = ref(false);
const personalData = ref(false);
const loadDistricts = ref(true);
const schoolData = ref(false);
const courseData = ref(false);
const documentData = ref(false);
const loading = ref(false);
const deficientTypeDisabled = ref(true);
const id_province = ref(0);

const userData = ref({
  fullName: "",
  address_location: "",
  email: "",
  gender: "",
  doc_type: "",
  doc_number: "",
  nactionality: "",
  birthDate: "",
  last_school_frequency: "",
  level_type: "",
  last_school_frequency_year: "",
  fathers_filliation: "",
  mothers_filliation: "",
  childhood_location: "",
  is_deficient: "",
  deficient_type: "",
  permissions: "",
  contact: "",
  alternative_contact: "",
  district_id: "",
  regimeSuperior: "",
});

const teacher = ref({});

const provincesData = ref([]);
const districtData = ref([]);
const DataCourse = ref([]);
const roles = ref([]);
const department = ref([]);
const classmates = ref([]);
const subjects = ref([]);
const permissions = ref([]);
const teacher_id = ref();
const route = useRoute();

const emailError = ref("");
const phoneNumberError = ref("");
const phoneNumberErrorAlternative = ref("");
const name_message_error = ref("");
const birthDate_message_error = ref("");
const district_message_error = ref("");
const address_message_error = ref("");
const doc_message_error = ref("");
const gender_message_error = ref("");
const isDeficient_message_error = ref("");
const father_name_message_error = ref("");
const mother_name_message_error = ref("");
const country_message_error = ref("");
const province_message_error = ref("");
const fullname_message_error = ref("");
const nationality_message_error = ref("");
const endereco_message_error = ref("");
const number_message_error = ref("");
const doc_number_message_error = ref("")

onMounted(() => {
  getProvinces();
  // getAllCourses();
  // getRoles();
  // getAllDepartment();
  // getAllClassmates();
  // getSubjects();
  // getAllpermissions();
  ShowProfessor();
  getYearTilCurrent();
});

const years = ref([]);

function getYearTilCurrent() {
  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 1900; year--) {
    years.value.push(year);
  }
}

async function ShowProfessor() {
  const resp = await TeacherStoreModule.actions.ShowTeacher(
    route.params.id_teacher
  );
  userData.value = resp.data.data.person;
  // teacher.value = resp.data.data.person;
  console.log(resp.data.data);
}
async function getAllDepartment() {
  const resp = await DepartmentStoreModule.actions.getAlldepartment();

  department.value = resp.data.data;
}

async function getAllClassmates() {
  const resp = await ClassMateStoreModule.actions.getTurmas();
  classmates.value = resp.data.data;
}

async function getSubjects() {
  const resp = await SubjectStoreModule.actions.getSubjects();
  subjects.value = resp.data.data;
}

async function getAllpermissions() {
  const resp = await permissionStoreModule.actions.getAllPermissions();
  permissions.value = resp.data;
  console.log(resp.data);
}

function clearInputs() {
  userData.address_location = "";
  userData.alternative_contact = "";
  userData.birthDate = "";
  userData.childhood_location = "";
  userData.contact = "";
  userData.course_id = "";
  userData.deficient_type = "";
  userData.district_id = "";
  userData.doc_number = "";
  userData.doc_type = "";
  userData.email = "";
  userData.father_filliation = "";
  userData.gender = "";
  userData.is_deficient = "";
  userData.last_school_frequency = "";
  userData.last_school_frequency_year = "";
  userData.level_type = "";
  userData.mother_filliation = "";
  userData.nationality = "";
  userData.name = "";
  userData.regime = "";
  userData.regimeSuperior = "";
}

function handleNextInfo() {
   

  if (userData.value.fullName == "") {
    fullname_message_error.value = "O campo nome nao pode estar vazio!";
    return;
  }

  if (userData.value.birthDate == "") {
    birthDate_message_error.value =
      "O campo data de nascimento nao pode estar vazio!";
    return;
  }

  if (userData.value.gender == "") {
    gender_message_error.value = "O campo genero nao pode estar vazio!";
    return;
  }

  if (userData.value.contact == "") {
    phoneNumberError.value = "O campo contacto nao pode estar vazio!";
    return;
  }

  // if (userData.value.is_deficient == "") {
  //   isDeficient_message_error.value =
  //     "O campo deficiencia nao pode estar vazio!";
  //   return;
  // }

  if (userData.value.fathers_filliation == "") {
    father_name_message_error.value =
      "O campo nome do pai nao pode estar vazio!";
    return;
  }

  if (userData.value.mothers_filliation == "") {
    mother_name_message_error.value =
      "O campo nome da mae nao pode estar vazio!";
    return;
  }

  firstInfoShow.value = false;
  secondInfoShow.value = true;
  personalData.value = false;
  documentData.value = true;
  console.log("hello", userData.value.is_deficient);
}

function handleStepTwo() {
  if (
    userData.doc_type == "" ||
    userData.doc_number == "" ||
    userData.nactionality == "" ||
    userData.provice == "" ||
    userData.district == "" ||
    userData.address_location == ""
  ) {
    return toastr.warning(
      "Por favor preecha os campos obrigatorios",
      "Opsssiiii"
    );
  }

  secondInfoShow.value = false;
  stepThreeInfo.value = true;
  documentData.value = false;
  schoolData.value = true;
}

function handleStepThree() {
  if (
    userData.last_school_frequency == "" ||
    userData.regime == "" ||
    userData.last_school_frequency_year == ""
  ) {
    return toastr.warning(
      "Por favor preecha os campos obrigatorios",
      "Opsssiiii"
    );
  }

  stepThreeInfo.value = false;
  stepFourInfo.value = true;
  schoolData.value = false;
  // couseData.value = true;
}

function handleStepFive() {
  if (userData.classmates[0] == "" || userData.subjects[0] == "") {
    return toastr.warning(
      "Por favor preecha os campos obrigatorios",
      "Opsssiiii"
    );
  }

  stepFourInfo.value = false;
  stepFiveInfo.value = true;
  // schoolData.value = false;
  // couseData.value = true;
}
function handleBackInfo() {
  secondInfoShow.value = false;
  firstInfoShow.value = true;
  documentData.value = false;
  personalData.value = true;
}

function handleBackDocument() {
  firstInfoShow.value = false;
  schoolData.value = false;
  documentData.value = true;
  secondInfoShow.value = true;
  stepThreeInfo.value = false;
}

function handleBackNivel() {
  stepThreeInfo.value = true;
  stepFourInfo.value = false;
}

function handleBackSchool() {
  schoolData.value = true;
  stepFourInfo.value = true;
  stepFiveInfo.value = false;
}

function goToFirstForm() {
  firstInfoShow.value = true;
  secondInfoShow.value = false;
  stepThreeInfo.value = false;
  stepFourInfo.value = false;
  personalData.value = true;
}

function is_deficientChange(evt) {
  console.log(evt.target.value);

  if (evt.target.value < 0 || evt.target.value == 0) {
    deficientTypeDisabled.value = true;
  } else {
    deficientTypeDisabled.value = false;
  }
}

function getRoles() {
  store
    .dispatch("Professor/fetchRoles")
    .then((response) => {
      roles.value = response.data;
      userData.permission_id = response.data[4].id;

      console.log(response.data);
      console.log(response.data[4].id);
    })
    .catch((error) => {
      console.log(error);
    });
}

async function handleSubmitButton() {
  try {
    loading.value = true;


    if (userData.value.doc_type == "") {
      doc_message_error.value =
        "O campo tipo de documeno não pode estar vazio!";
    }

    if (userData.value.doc_number == "") {
      doc_number_message_error.value =
        "O campo numero do documeno não pode estar vazio!";
    }

     if (userData.value.nactionality == "") {
      nationality_message_error.value =
        "O campo naciolidade não pode estar vazio!";
    }

     if (userData.value.province_id == "") {
      province_message_error.value =
        "O campo provincia  não pode estar vazio!";
    }

     if (userData.value.doc_number == "") {
      endereco_message_error.value =
        "O campo endereco não pode estar vazio!";
    }


    const resp = await TeacherStoreModule.actions.updateTeacher(
      route.params.id_teacher,
      userData.value
    );
    if (resp.data.status == true) {
      toastr.success(resp.data.message);
      firstInfoShow.value = true;
      stepThreeInfo.value = false;
    } else {
      toastr.error(resp.data.message);
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function getProvinces() {
  const resp = await TeacherStoreModule.actions.fetchProvinces();
  provincesData.value = resp.data;

  console.log(resp.data);
  // store
  //   .dispatch("Professor/fetchProvinces")
  //   .then((response) => {
  //     provincesData.value = response.data;
  //     console.log(response.data);
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
}

async function ChangeProvince(evt) {
  loadDistricts.value = true;
  id_province.value = evt.target.value;
  console.log(evt.target.value);

  const resp = await TeacherStoreModule.actions.fetchDistricts(
    id_province.value
  );
  districtData.value = resp.data;
  loadDistricts.value = false;

  console.log(resp.data);
  // store
  //   .dispatch("Professor/fetchDistricts", id_province.value)
  //   .then((response) => {
  //     districtData.value = response.data;
  //     loadDistricts.value = false;
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
}

function getAllCourses() {
  store
    .dispatch("Professor/getAllCourses")
    .then((response) => {
      // console.log(response);
      DataCourse.value = response.data;
    })
    .catch((error) => {
      console.log(error);
    });
}

function numberOnly($event) {
  let keycode = $event.keyCode ? $event.keyCode : $event.which;

  if ((keycode < 48 || keycode > 57) && keycode !== 46) {
    $event.preventDefault();
  }
}
</script>
  